module.exports = __webpack_public_path__ + "img/contacto_16-9.0c5131f9.webp";